<div class="bg-m0 flex select-none flex-col p-9">
  <div
    data-cy="renameFileDialogTitle"
    class="text-s2 mt-5 flex-grow text-left text-2xl font-semibold"
    >Rename File</div
  >

  <form
    class="flex w-[450px] flex-col"
    [formGroup]="renameFileForm"
    (ngSubmit)="save()"
  >
    <div class="mt-9 text-base">Name</div>
    <input
      #fileName
      autocomplete="off"
      spellcheck="false"
      data-cy="renameFileDialogFileNameInput"
      class="form-input border-s3 focus:border-m600 mt-2 h-[36px] rounded"
      [ngClass]="{
        'border-r600':
          renameFileForm.controls['fileName'].invalid &&
          renameFileForm.controls['fileName'].touched
      }"
      formControlName="fileName"
      placeholder="File Name"
    />
    <m-validation
      [control]="renameFileForm.controls['fileName']"
    ></m-validation>

    <div class="mt-9">
      <button
        data-cy="renameFileDialogSaveButton"
        class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
        type="submit"
        >Save</button
      >

      <button
        data-cy="renameFileDialogCancelButton"
        class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
        type="button"
        (click)="cancel()"
        >Cancel</button
      >
    </div>
  </form>
</div>
